/**
 * Global axios setup.
 *
 * - Adds `Authorization: Bearer <token>` from localStorage on every request.
 * - Adds `X-Farm-Id: <farm_id>` whenever the super admin is impersonating a
 *   farm (localStorage key `impersonated_farm_id`). The backend honours that
 *   header to scope tenant queries to that farm.
 */
import axios from 'axios';

let installed = false;

export function installAxiosInterceptors() {
  if (installed) return;
  installed = true;
  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    const farmId = localStorage.getItem('impersonated_farm_id');
    if (farmId) {
      config.headers = config.headers || {};
      config.headers['X-Farm-Id'] = farmId;
    }
    return config;
  });
}

export function startImpersonating(farmId, farmName) {
  localStorage.setItem('impersonated_farm_id', farmId);
  if (farmName) localStorage.setItem('impersonated_farm_name', farmName);
}

export function stopImpersonating() {
  localStorage.removeItem('impersonated_farm_id');
  localStorage.removeItem('impersonated_farm_name');
}

export function getImpersonation() {
  const id = localStorage.getItem('impersonated_farm_id');
  if (!id) return null;
  return { farmId: id, farmName: localStorage.getItem('impersonated_farm_name') };
}
